import { useRef, useState } from 'react';
import useClickOutside from '../useclickoutside/useclickoutside';
import { IconPencil, IconTrash } from '@veneer/core';
import { useTranslation } from 'react-i18next';

const EditAction = ({ item, setSelectedRowItem, setSelectedNickName, setOpen, setActionType }: any) => {
  const dropDownRef = useRef<HTMLDivElement>(null);
  const [isActive, setIsActive] = useState(false);
  const { t } = useTranslation();

  const closeHandler = () => {
    setIsActive(false);
  };

  useClickOutside(dropDownRef, closeHandler);

  const openEditOption = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setSelectedRowItem(item);
    setSelectedNickName(item.nickname);
    setIsActive(!isActive);
  };

  const selectHandler = (type: any) => {
    setOpen(true);
    setActionType(type);
    closeHandler();
  };

  return (
    <div className="edit-button" ref={dropDownRef}>
      <button className="edit-option-button" onClick={openEditOption}>
    <svg aria-hidden="true" fill="bule" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="vn-icon-inactive css-1dia7hu"><path d="M4.73016 10.0185C4.26394 10.0902 3.86394 10.2942 3.55283 10.6208C3.27437 10.9137 3.10113 11.2639 3.02403 11.6874C3.00045 11.8171 3.00045 12.1836 3.02403 12.3133C3.06394 12.5346 3.12109 12.7106 3.2127 12.8929C3.51292 13.497 4.09252 13.9033 4.77279 13.9868C4.89161 14.0022 5.21905 13.994 5.3288 13.9732C5.54467 13.9332 5.6907 13.8861 5.88208 13.7917C6.48889 13.4942 6.89433 12.9255 6.98503 12.2453C6.99138 12.1981 6.99682 12.0874 6.99682 12.0004C6.99682 11.9133 6.99138 11.8026 6.98503 11.7555C6.90703 11.1659 6.59229 10.6616 6.09705 10.3287C6.00181 10.2652 5.77687 10.1527 5.6653 10.1147C5.57188 10.082 5.44399 10.0484 5.3288 10.0267C5.21723 10.0058 4.84535 10.0004 4.73016 10.0185ZM11.7034 10.023C11.2635 10.0911 10.8753 10.2915 10.566 10.609C10.3293 10.853 10.1614 11.1441 10.0726 11.4698C10.0181 11.6711 10.0091 11.7437 10.0091 12.0004C10.0091 12.2571 10.0181 12.3296 10.0726 12.531C10.2839 13.3038 10.9424 13.8761 11.7406 13.9822C11.9002 14.004 12.2041 13.9976 12.3492 13.9695C12.7565 13.8924 13.1029 13.7147 13.3914 13.4344C13.7007 13.1323 13.8966 12.7614 13.9737 12.3269C13.9982 12.1899 13.9982 11.8108 13.9737 11.6738C13.8966 11.2394 13.7007 10.8684 13.3914 10.5664C13.1029 10.2861 12.7574 10.1083 12.3492 10.0303C12.2023 10.0031 11.8594 9.99855 11.7034 10.023ZM18.7891 10.0112C18.5478 10.0403 18.3483 10.0983 18.1406 10.1963C17.5238 10.4911 17.1066 11.0679 17.015 11.7555C17.0086 11.8026 17.0032 11.9133 17.0032 12.0004C17.0032 12.0874 17.0086 12.1981 17.015 12.2453C17.1048 12.921 17.5102 13.4915 18.1088 13.7881C18.4 13.9314 18.6231 13.9859 18.9524 13.9931C19.2245 13.9995 19.3887 13.9768 19.6236 13.8997C20.2685 13.6874 20.7664 13.1577 20.9333 12.5056C20.985 12.3042 20.9923 12.2407 20.9923 12.0004C20.9923 11.76 20.985 11.6965 20.9333 11.4951C20.7338 10.7151 20.0744 10.1319 19.2671 10.0194C19.1737 10.0058 18.8707 10.0013 18.7891 10.0112Z"></path></svg>

      </button>
      {isActive && (
        <div className="edit-option-popup active">
          <ul>
            <li onClick={() => selectHandler(1)}>
              <span>
                <IconPencil size={25} /> {t('HPI.Contractwarranties.Editnickname',{defaultValue:'Edit nick name'})}
              </span>
            </li>
            <li onClick={() => selectHandler(2)}>
              <span>
                <IconTrash size={25} /> {t('HPI.Contractwarranties.delete',{defaultValue:'Delete'})}
              </span>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default EditAction;
